import { render, staticRenderFns } from "./EditFinancialTransaction.vue?vue&type=template&id=16483bc1"
import script from "./EditFinancialTransaction.vue?vue&type=script&lang=js"
export * from "./EditFinancialTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports